import { REQUIRED_ONBOARDING_FIELDS, REQUIRED_ONBOARDING_FIELDS_WITHOUT_ADDRESS } from 'app/stores/user';
import { useMemo } from 'react';
import { useOnboardingContext } from './useOnboarding';

export const useOnboardingValidation = (skipAddress?: boolean) => {
  const { errors, profile } = useOnboardingContext();

  const isValidUserProfile = useMemo(() => {
    const requiredFields = skipAddress ? REQUIRED_ONBOARDING_FIELDS_WITHOUT_ADDRESS : REQUIRED_ONBOARDING_FIELDS;

    return requiredFields.every((field) => !!profile[field]) && !errors.profile;
  }, [profile, errors, skipAddress]);

  const isValidDateOfBirth = useMemo(() => profile.dob && !errors.dob, [profile, errors]);

  const isValidGender = useMemo(() => profile.gender && !errors.gender, [profile, errors]);

  return { isValidUserProfile, isValidDateOfBirth, isValidGender };
};
